import React, { useCallback, useEffect, useRef, useState } from "react";
import Icons from "../../../../Config/Images";
import "./MenuList.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getMetalColorAPI,
  getProductMetalDetailsAPI,
} from "../../../../Store/Action/productMetalAction";
import { getProductPurityDetailsAPI } from "../../../../Store/Action/productPurityAction";
import { getGlobalFilterAPI } from "../../../../Store/Action/globalFilterAction";
import {
  appliedFilter,
  clearFilters,
  setFilter,
} from "../../../../Store/Slice/productSlice";
import { fileDriveName } from "../../../../Constants/AppConstants";
import {
  applyFilters,
  resetFilters,
} from "../../../../Store/Slice/filterSlice";
import { filter } from "@chakra-ui/react";

const MenuList = ({
  prodCatId,
  prodMetalId,
  prodSubCategoryId,
  screen_name,
  page,
  selectedFilters,
  screen_name_from_filter,
  manufacturerId,
  viewAllTopSellingProducts,
}) => {

  const dispatch = useDispatch();
  // const dropdownRef = useRef(null);
  const dropdownRefs = useRef([]); // Store multiple dropdown refs
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [weightRange, setWeightRange] = useState({ min: "", max: "" });
  const [wastageSort, setWastageSort] = useState("");
  const [colorStoneOptions, setColorStoneOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [useEffectTrigger, setUseEffectTrigger] = useState(0);
  const [caratOptions, setCaratOptions] = useState([]);
  const [isUserAction, setIsUserAction] = useState(false);

  const lastPayloadRef = useRef(null);
  const isFirstRender = useRef(true);


  // const [filtersReady, setFiltersReady] = useState(false); // New state to control API call
  // filter.js file code----------------------------------------------------------------
  const [selectedOption, setSelectedOption] = useState("Featured");
  const [isOpen, setIsOpen] = useState(false);
  const options = ["A-Z", "Z-A", "Best selling", "New collection"];

  const handleRadioChange = (option) => {
    setIsUserAction(true);
    // Update the selected option and reset the filter state
    const newFilter = {
      ...filters, // Keep existing filter values
      featured: false,
      a_z: false,
      z_a: false,
      best_selling: false,
      new_collection: false,
    };

    switch (option) {
      case "A-Z":
        newFilter.a_z = true;
        break;
      case "Z-A":
        newFilter.z_a = true;
        break;
      case "Best selling":
        newFilter.best_selling = true;
        break;
      case "New collection":
        newFilter.new_collection = true;
        break;
      default:
        newFilter.featured = true;
    }
    // setFiltersReady(true);
    setFilters(newFilter);
    setSelectedOption(option);
    setIsOpen(false); // Close the dropdown
  };
  const toggleDropdownFilter = () => {
    setIsOpen(!isOpen);
  };
  // const [productSubCatId, setProductSubCatId] = useState([]);
  // useEffect(() => {
  //   setProductSubCatId(prodCatId.split(",") );
  // }, []);
  const [wastageOptions, setWastageOptions] = useState([]);
  const [filters, setFilters] = useState({
    carat: [],
    metal: [], //change here to metal
    color_stone: [],
    wastageSort: "",
    weightRange: { min_net_weight: "", max_net_weight: "" },
    featured: true,
    a_z: false,
    z_a: false,
    best_selling: false,
    new_collection: false,
    product_subcategory_id: [],
    manufacturer_id: [],
    view_all_top_selling_products: false,
  });

  // Use useEffect to update product_subcategory_id in the filters state when prodCatId changes
  useEffect(() => {
    if (prodCatId) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        product_subcategory_id: prodCatId.split(","),
      }));
    }
  }, [prodCatId]);

  useEffect(() => {
    if (prodMetalId) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        product_metal_id: prodMetalId,
      }));
    }
  }, [prodMetalId]);
  useEffect(() => {
    if (prodSubCategoryId) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        product_subcategory_id: prodSubCategoryId,
      }));
    }
  }, [prodSubCategoryId, useEffectTrigger]);

  useEffect(() => {
    if (manufacturerId) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        manufacturer_id: manufacturerId,
      }));
    }
  }, [manufacturerId, useEffectTrigger]);

  useEffect(() => {
    if (screen_name) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        screen_name: screen_name,
      }));
    }
  }, [screen_name, useEffectTrigger]);
  // const [prodTotalCount, setProdTotalCount] = useState(0);

  // const [filteredData, setFilteredData] = useState([]); // Store filtered data
  useEffect(() => {
    if (selectedFilters && screen_name === screen_name_from_filter) {

      const {
        product_stamp_value, // ❌ remove this
        ...cleanFilters
      } = selectedFilters;

      setFilters((prev) => ({
        ...prev,
        ...cleanFilters,
      }));
    }
  }, []);


  useEffect(() => {
    if (viewAllTopSellingProducts) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        view_all_top_selling_products: viewAllTopSellingProducts,
      }));
    }
  }, [viewAllTopSellingProducts, useEffectTrigger]);

  const user = useSelector((state) => state.auth.user);
  const userRoleId = user?.user_role_id;
  let userRole;
  if (userRoleId == 4) {
    userRole = "Retailer";
  } else if (userRoleId == 5) {
    userRole = "Wholeseller";
  }

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const handleResetFilters = () => {
    setIsUserAction(false);
    // Reset the local filter state
    setFilters((prevFilters) => ({
      ...prevFilters,
      carat: [],
      metal: [],
      color_stone: [],
      wastageSort: "",
      weightRange: { min_net_weight: "", max_net_weight: "" },
      featured: true,
      a_z: false,
      z_a: false,
      best_selling: false,
      new_collection: false,
      // product_subcategory_id: [],
      // product_metal_id: "",
      screen_name: "",
      view_all_top_selling_products: false
    }));

    // Reset the filters in the Redux store
    // dispatch(clearFilters());
    // setFiltersReady(false); // Disable API call
    // Reset the dropdown and any other UI-related state
    setActiveDropdown(null); // Close any open dropdowns
    setWeightRange({ min: "", max: "" }); // Reset weight range input
    setWastageSort(""); // Reset wastage sort option
    setSelectedOption("featured"); // Reset selected option
    dispatch(resetFilters());
    // 🔥 Manually trigger useEffect hooks
    setUseEffectTrigger((prev) => prev + 1);
    // resetFilterAgain()
  };

  const handleWeightChange = (e) => {
    const { name, value } = e.target;

    // Ensure the value is a valid number or keep it as an empty string
    // const numericValue = value ? parseFloat(value) : "";

    // setWeightRange((prev) => ({
    //   ...prev,
    //   [name]: numericValue,
    // }));

    // Allow only numbers and a single decimal point
    if (/^\d*\.?\d*$/.test(value)) {
      setWeightRange((prev) => ({
        ...prev,
        [name]: value, // Store as string to preserve decimals and leading 0s
      }));
    }
  };

  const applyWeightFilter = () => {
    setIsUserAction(true);
    setFilters((prev) => ({
      ...prev,
      weightRange: {
        min_net_weight: weightRange.min || "",
        max_net_weight: weightRange.max || "",
      },
    }));

    // setFiltersReady(true); // Enable API call
    // fetchFilteredData(); // Fetch updated results
    setActiveDropdown(null); // Close dropdown
  };

  // const handleWastageChange = (value) => {
  //   setWastageSort(value);
  //   setFilters((prev) => ({ ...prev, wastageSort: value }));
  //   setFiltersReady(true);
  // };
  // const handleWastageChange = (event) => {
  //   const value = event.target.value;
  //   setWastageSort(value);
  //   setFilters((prev) => ({ ...prev, wastageSort: value }));
  //   setFiltersReady(true);
  // };

  // const handleWastageChange = (event) => {
  //   if (!event || !event.target) return; // Prevents undefined errors

  //   const { value } = event.target; // Extract the value safely

  //   setWastageSort(value); // Update state
  //   setFilters((prev) => ({
  //     ...prev,
  //     wastageSort: value,
  //   }));

  //   setFiltersReady(true); // Enable API call

  // };

  const handleWastageChange = (event) => {
    setIsUserAction(true);
    const { value } = event.target; // Get value from event
    setWastageSort(value); // Update state
    setFilters((prev) => ({ ...prev, wastageSort: value })); // Update filters
    // setFiltersReady(true); // Enable API call
  };
  const handleFilterChange = useCallback((filterKey, value) => {
    setIsUserAction(true);
    setFilters((prev) => {
      const updated = { ...prev };

      if (filterKey === "metal") updated.metal = value;
      if (filterKey === "carat") updated.carat = value;
      if (filterKey === "color_stone") updated.color_stone = value;

      return updated;
    });
  }, []);


  useEffect(() => {
    if (!caratOptions.length) return;

    // 🚫 BLOCK auto calls
    if (!isUserAction) return;

    const selectedCaratValues = filters.carat
      ?.map((id) => {
        const match = caratOptions.find((opt) => opt.id === id);
        return match ? match.name : null;
      })
      .filter(Boolean);

    // ✅ REMOVE carat safely
    const { carat, ...restFilters } = filters;

    const apiPayload = {
      ...restFilters,
      ...(selectedCaratValues.length > 0 && {
        product_stamp_value: selectedCaratValues,
      }),
    };


    delete apiPayload.carat;

    const payloadString = JSON.stringify(apiPayload);

    // 🚫 prevent duplicate calls
    if (lastPayloadRef.current === payloadString) return;

    lastPayloadRef.current = payloadString;

    dispatch(
      getGlobalFilterAPI(apiPayload, (result) => {
        dispatch(
          applyFilters({
            selectedFilters: filters,
            appliedFilters: result,
          })
        );
      }, 1)
    );
  }, [filters, caratOptions, dispatch]);


  // useEffect(() => {
  //   if (filtersReady) {
  //     // 👇 Convert IDs to actual values like "14k"
  //     const selectedCaratValues = filters.carat.map((id) => {
  //       const match = caratOptions.find((opt) => opt.id === id);
  //       return match ? match.name : null;
  //     }).filter(Boolean); // remove nulls

  //     const apiPayload = {
  //       ...filters,
  //       product_stamp_value: selectedCaratValues, // ✅ send values
  //     };

  //     delete apiPayload.carat;

  //     dispatch(
  //       getGlobalFilterAPI(
  //         apiPayload,
  //         (result) => {
  //           // dispatch selected filterssss

  //           // dispatch(applyFilters(result));
  //           dispatch(
  //             applyFilters({
  //               selectedFilters: filters,
  //               appliedFilters: result,
  //             })
  //           );
  //         },
  //         1
  //       )
  //     );
  //   }
  // }, [filters, filtersReady, dispatch]);

  // Fetch product metal details and update dropdown options
  useEffect(() => {
    dispatch(
      getProductMetalDetailsAPI({}, (response) => {
        if (response?.status && response?.data) {
          const metalOptions = response.data.map((metal) => ({
            id: metal.product_metal_id,
            name: metal.product_metal_name,
          }));
          setColorStoneOptions(metalOptions); // Set Color Stone options
        }
      })
    );

    dispatch(
      getMetalColorAPI({}, (response) => {
        const colorOptions = response?.map((color) => ({
          id: color?.color_stone_id,
          name: color?.color_stone_name,
        }));
        setColorOptions(colorOptions);
      })
    );
    dispatch(
      getProductPurityDetailsAPI({}, (result) => {
        if (result?.status && result?.data) {
          const purityOptions = result.data.map((purity) => ({
            id: purity.stamp_melting_id, // Assuming this is the ID field for purity
            name: purity.stamp_value, // Assuming this is the name/label field for purity
          }));
          setCaratOptions(purityOptions); // Set Carat options
        }
      })
    );

    // Example for wastage options (if needed in future)
    setWastageOptions(["Option 1", "Option 2"]); // Placeholder for Wastage options
  }, [dispatch]);

  const renderDropdownContent = (index) => {
    if (index === 0) {
      return (
        <div className="custom-weight-dropdown">
          <p>Weight Between</p>
          <input
            type="text"
            placeholder="Min Weight (gm)"
            name="min"
            value={weightRange.min || ""}
            onChange={handleWeightChange}
          />
          <p>To</p>
          <input
            type="text"
            placeholder="Max Weight (gm)"
            name="max"
            value={weightRange.max || ""}
            onChange={handleWeightChange}
          />
          <button onClick={applyWeightFilter}>Apply</button>
        </div>
      );
    }

    if (index === 1) {
      return (
        <div className="menu-dropdown">
          <ul>
            {colorStoneOptions?.map((option, optIndex) => (
              <li key={optIndex}>
                <input
                  className={`inputt-checkbox ${filters?.metal?.includes(option.id) ? "checked" : ""
                    }`}
                  type="checkbox"
                  id={`colorStone-${option.id}`}
                  value={option.id}
                  checked={filters?.metal?.includes(option.id)} // Preserve the state of selected checkboxes
                  onChange={(e) =>
                    handleFilterChange(
                      "metal",
                      e.target.checked
                        ? [...filters.metal, option.id]
                        : filters?.metal.filter((item) => item !== option.id)
                    )
                  }
                />
                <label
                  className="label-name"
                  htmlFor={`colorStone-${option.id}`}
                >
                  {option.name}
                </label>
              </li>
            ))}
          </ul>
        </div>
      );
    }
    if (index === 2) {
      return (
        <div className="menu-dropdown">
          <ul>
            {colorOptions?.map((option, optIndex) => (
              <li key={optIndex}>
                <input
                  className="inputt-checkbox"
                  type="checkbox"
                  id={`color-${option.id}`}
                  value={option.id}
                  checked={filters.color_stone.includes(option.id)}
                  onChange={(e) =>
                    handleFilterChange(
                      "color_stone",
                      e.target.checked
                        ? [...filters.color_stone, option.id]
                        : filters.color_stone.filter(
                          (item) => item !== option.id
                        )
                    )
                  }
                />
                <label className="label-name" htmlFor={`color-${option.id}`}>
                  {option.name}
                </label>
              </li>
            ))}
          </ul>
        </div>
      );
    }
    if (index === 3) {
      return (
        <div className="menu-dropdown">
          <ul>
            {caratOptions.map((option, optIndex) => {
              return (
                <li key={optIndex}>
                  <input
                    className="inputt-checkbox"
                    type="checkbox"
                    id={`carat-${option.id}`}
                    value={option.id}
                    checked={filters.carat.includes(option.id)} // Preserve the state of selected checkboxes
                    onChange={(e) =>
                      handleFilterChange(
                        "carat",
                        e.target.checked
                          ? [...filters.carat, option.id]
                          : filters.carat.filter((item) => item !== option.id)
                      )
                    }
                  />
                  <label className="label-name" htmlFor={`carat-${option.id}`}>
                    {option.name}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      );
    }

    if (index === 4) {
      return (
        <div className="wastage-dropdown">
          <div
            className="wastage-option"
          // onClick={() => handleWastageChange("high-to-low")}
          >
            <input
              type="radio"
              id="high-to-low"
              name="wastageSort"
              value="high-to-low"
              checked={wastageSort === "high-to-low"}
              // onChange={() => handleWastageChange("high-to-low")}
              // onChange={(event) => handleWastageChange(event)}
              onChange={handleWastageChange}
              className="inputt-radioo"
            />
            <label htmlFor="high-to-low">
              High to Low
              <img src={Icons.down_arrow_icon} alt="Down Arrow" />
            </label>
          </div>
          <div
            className="wastage-option"
          // onClick={() => handleWastageChange("low-to-high")}
          >
            <input
              type="radio"
              id="low-to-high"
              name="wastageSort"
              value="low-to-high"
              checked={wastageSort === "low-to-high"}
              // onChange={() => handleWastageChange("low-to-high")}
              onChange={handleWastageChange}
              // onChange={(event) => handleWastageChange(event)}
              className="inputt-radioo"
            />
            <label htmlFor="low-to-high">
              Low to High
              <img src={Icons.up_arrow_icon} alt="Up Arrow" />
            </label>
          </div>
        </div>
      );
    }

    return null;
  };

  const [smallScreenMenuOpen, setSmallScreenMenuOpen] = useState(false);
  const sidebarRef = useRef(null); // Create a ref for the sidebar
  const toggleSmallScreenMenu = () => {
    setSmallScreenMenuOpen(!smallScreenMenuOpen);
  };

  // Close the sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSmallScreenMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setActiveDropdown(null);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if clicked outside sidebar
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSmallScreenMenuOpen(false);
      }

      // Ensure dropdownRefs.current is an array before using .every()
      if (
        Array.isArray(dropdownRefs.current) &&
        dropdownRefs.current.length > 0 &&
        dropdownRefs.current.every((ref) => ref && !ref.contains(event.target))
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="menu" ref={dropdownRefs}>
        <ul className="menusUl">
          {["Weight", "Metal", "Color", "Carat", "Wastage"].map(
            (item, index) => (
              <div className="divLists" key={index}>
                <div className="li1">
                  <li
                    style={{ cursor: "pointer" }}
                    className="list1"
                    onClick={() => toggleDropdown(index)}
                  >
                    {item}
                  </li>
                </div>
                <div
                  className="liImg"
                  onClick={() => toggleDropdown(index)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    style={{ height: "7px", width: "14px" }}
                    className="icon"
                    src={
                      activeDropdown === index
                        ? Icons.vectorUpIcon
                        : Icons.vectorDownIcon
                    }
                    alt=""
                  />
                </div>
                {activeDropdown === index && renderDropdownContent(index)}
              </div>
            )
          )}
        </ul>
      </div>
      <div className="reset-btn-div">
        <button className="reset-btn" onClick={handleResetFilters}>
          Reset Filters
        </button>
      </div>

      {/* Mobile Menu */}
      {/* Hamburger Button for Mobile */}
      {/* <button className="hamburger-btn" onClick={toggleSmallScreenMenu}>
        <img src={Icons.ham_menu_img} alt="Menu" />
      </button> */}
      <div className="hamburger-btn" onClick={toggleSmallScreenMenu}>
        <img src={Icons.filterIcon} alt="" />
        <p className="filter-paraa">Filter</p>
      </div>

      {/* Mobile Sliding Menu */}
      <div
        ref={sidebarRef}
        className={`side-menu ${smallScreenMenuOpen ? "open" : ""}`}
      >
        <button className="close-btn" onClick={toggleSmallScreenMenu}>
          ✖
        </button>
        <ul className="side-menu-list">
          {/* {["Weight", "Color Stone", "Carat", "Wastage"].map((item, index) => (
            <>
              <li key={index} onClick={() => toggleDropdown(index)}>
                {item}
                <img
                  className="icon"
                  src={
                    activeDropdown === index
                      ? Icons.vectorUpIcon
                      : Icons.vectorDownIcon
                  }
                  alt=""
                />
              </li>
              {activeDropdown === index && renderDropdownContent(index)}
            </>
          ))} */}
          {["Weight", "Metal", "Color", "Carat", "Wastage"].map(
            (item, index) => (
              <div className="divLists" key={index}>
                <div className="li1">
                  <li className="list1">{item}</li>
                </div>
                <div
                  className="liImg"
                  // onClick={() => toggleDropdown(index)}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents bubbling issues
                    toggleDropdown(index);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    style={{ height: "7px", width: "14px" }}
                    className="icon"
                    src={
                      activeDropdown === index
                        ? Icons.vectorUpIcon
                        : Icons.vectorDownIcon
                    }
                    alt=""
                  />
                </div>
                {activeDropdown === index && renderDropdownContent(index)}
              </div>
            )
          )}
        </ul>
        {/* Reset Filters Button */}
        <div className="reset-btn-div-side-menu">
          <button className="reset-btn-side-menu" onClick={handleResetFilters}>
            Reset Filters
          </button>
        </div>
      </div>

      {/* Overlay when Menu is Open */}
      {smallScreenMenuOpen && (
        <div className="overlay" onClick={toggleSmallScreenMenu}></div>
      )}

      <div className="custom-dropdown-filter">
        <p className="sort-by-para">Sort by :</p>
        <div className="dropdown-header" onClick={toggleDropdownFilter}>
          {selectedOption}
          <img
            style={{ height: "7px", width: "14px" }}
            src={isOpen ? Icons.vectorUpIcon : Icons.vectorDownIcon}
            alt={isOpen ? "Up arrow" : "Down arrow"}
            className="arrow-icon"
          />
        </div>
        {isOpen && (
          <div className="dropdown-menu">
            {options.map((option, index) => (
              <label key={index} className="dropdown-item">
                <input
                  type="radio"
                  name="filter-option"
                  value={option}
                  checked={selectedOption === option}
                  onChange={() => handleRadioChange(option)}
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default MenuList;
